<div [ngSwitch]="format" [class.opacity-65]="control.disabled === true">

    <div *ngSwitchCase="'currency'" class="slider-selection-vals">
        {{title}}
        <ng-container *ngIf="control.value[0] === control.value[1]">
            {{handleMaxText === true && control.value[1]===this.range.max ? 'Más de ' : ''}}
            <span class="dark-blue font-weight-bold text-primary">{{control.value[1] | currencyLocal}}{{handleMaxText
                === false && control.value[1]===this.range.max?secondaryMaxText:''}}</span>&nbsp;{{control.value[1] > 1
            ? titleValuesPlural : titleValuesSingular}}
        </ng-container>


        <ng-container *ngIf="control.value[0] !== control.value[1]">
            Entre&nbsp;
            <span class="dark-blue font-weight-bold text-primary">{{control.value[0] |
                currencyLocal}}</span>&nbsp;y&nbsp;
            <span class="dark-blue font-weight-bold text-primary">{{control.value[1] |
                currencyLocal}}{{control.value[1]===this.range.max?secondaryMaxText:''}}</span>&nbsp;{{control.value[1]
            > 1 ? titleValuesPlural : titleValuesSingular}}
        </ng-container>

    </div>

    <div *ngSwitchCase="'percentage'" class="slider-selection-vals">

        <ng-container *ngIf="control.value[0] === control.value[1]">
            {{handleMaxText === true && control.value[1]===this.range.max ? 'Más de ' : ''}}
            <span class="dark-blue font-weight-bold text-primary">{{control.value[1] }}%{{handleMaxText === false &&
                control.value[1]===this.range.max?secondaryMaxText:''}}</span>&nbsp;{{control.value[1] > 1 ?
            titleValuesPlural : titleValuesSingular}}
        </ng-container>


        <ng-container *ngIf="control.value[0] !== control.value[1]">
            Entre&nbsp;
            <span class="dark-blue font-weight-bold text-primary">{{control.value[0] }}%</span>&nbsp;y&nbsp;
            <span class="dark-blue font-weight-bold text-primary">{{control.value[1]
                }}%{{control.value[1]===this.range.max?secondaryMaxText:''}}</span>&nbsp;{{control.value[1] > 1 ?
            titleValuesPlural : titleValuesSingular}}
        </ng-container>

    </div>

    <div *ngSwitchCase="'languageLevel'" class="slider-selection-vals">
        {{title}} <span class="dark-blue font-weight-bold text-primary">{{control.value |
            languageLevelNameSlider}}</span>
    </div>

    <div *ngSwitchCase="'priorityEmployee'" class="slider-selection-vals">

        {{title}} <span class="dark-blue font-weight-bold text-primary">{{control.value |
            priorityEmployeeLabelSlider}}</span>

    </div>

    <div *ngSwitchCase="'upperNumber'" class="slider-selection-vals">

        {{title}} <span class="dark-blue font-weight-bold text-primary">{{control.value }} o más</span>

    </div>

    <div *ngSwitchCase="'levelGrade'" class="slider-selection-vals">
        Desde&nbsp;<span class="dark-blue font-weight-bold">{{labelFrom}}</span>&nbsp;-&nbsp;hasta&nbsp;<span
            class="dark-blue font-weight-bold">{{labelTo}}</span>
    </div>

    <div *ngSwitchDefault class="slider-selection-vals">

        <ng-container *ngIf="control.value[0] === control.value[1] && (+control.value[1] + +control.value[0]) !== 0">
            {{handleMaxText === true && control.value[1]===this.range.max ? 'Más de ' : ''}}
            <span class="dark-blue font-weight-bold text-primary">{{control.value[1]}}{{handleMaxText === false &&
                control.value[1]===this.range.max?secondaryMaxText:''}}</span>&nbsp;{{control.value[1] > 1 ?
            titleValuesPlural : titleValuesSingular}}
        </ng-container>

        <ng-container *ngIf="control.value[0] === control.value[1] && (+control.value[1] + +control.value[0]) === 0">
            Entre&nbsp;
            <span class="dark-blue font-weight-bold text-primary">{{control.value[0]}}</span>&nbsp;y&nbsp;
            <span
                class="dark-blue font-weight-bold text-primary">{{control.value[1]}}{{control.value[1]===this.range.max?secondaryMaxText:''}}</span>&nbsp;{{control.value[1]
            > 1 ? titleValuesPlural : titleValuesSingular}}
        </ng-container>


        <ng-container *ngIf="control.value[0] !== control.value[1]">
            Entre&nbsp;
            <span class="dark-blue font-weight-bold text-primary">{{control.value[0]}}</span>&nbsp;y&nbsp;
            <span
                class="dark-blue font-weight-bold text-primary">{{control.value[1]}}{{control.value[1]===this.range.max?secondaryMaxText:''}}</span>&nbsp;{{control.value[1]
            > 1 ? titleValuesPlural : titleValuesSingular}}
        </ng-container>

    </div>
</div>

<div [id]="id" class="my-uislider mgn-bottom-15" [class.invalid-range]="invalidMaxRange && control.enabled">

    <nouislider #nouisliderlinear (change)="onChangeValuesSlider()" (update)="onUpdateValuesSlider()" [min]="range.min"
        [max]="range.max" [step]="range.step" [connect]="connect" [formControl]="control"></nouislider>

</div>